function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import { getLewisVersion } from 'researcher/digital-editing/actions';
import RubriqLoadingSpinner from '../components/RubriqLoadingSpinner';
import { RUBRIQ_FEATURES, RUBRIQ_LEWIS_VERSION_MAP, RUBRIQ_LANGUAGE_LABELS } from '../constants';
import { shouldShowFeatureFeedbackNotification } from '../helpers/featureSurveyLastShownAt';
import RubriqPaginator from './RubriqPaginator';
import RubriqDocumentCard from './RubriqDocumentCard';
import RubriqFeatureFeedbackToastNotification from './RubriqFeatureFeedbackToastNotification';
var RubriqDocumentList = function RubriqDocumentList(_ref) {
  var documents = _ref.documents,
    status = _ref.status,
    pagination = _ref.pagination,
    _ref$isTranslationLis = _ref.isTranslationList,
    isTranslationList = _ref$isTranslationLis === void 0 ? false : _ref$isTranslationLis;
  var numberOfResults = pagination.numberOfResults,
    page = pagination.page,
    pageSize = pagination.pageSize;
  var _useState = useState({
      documentIdentity: '',
      lewisVersion: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    downloadedDocumentDetails = _useState2[0],
    setDownloadedDocumentDetails = _useState2[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;

  // eslint-disable-next-line no-unused-vars
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  var dispatch = useDispatch();
  var handleDownload = function handleDownload(documentIdentity) {
    var _curie$access$feature;
    var currentFeature = isTranslationList ? RUBRIQ_FEATURES.TRANSLATION : RUBRIQ_FEATURES.EDITING;
    var numberOfFeatureRunsUsed = (_curie$access$feature = curie.access.features[currentFeature].usesConsumed) !== null && _curie$access$feature !== void 0 ? _curie$access$feature : 0;
    if (shouldShowFeatureFeedbackNotification(currentFeature, numberOfFeatureRunsUsed)) {
      if (currentFeature === RUBRIQ_FEATURES.EDITING) {
        dispatch(getLewisVersion(documentIdentity)).then(function (_ref2) {
          var lewisVersion = _ref2.lewisVersion;
          return setDownloadedDocumentDetails({
            documentIdentity: documentIdentity,
            lewisVersion: lewisVersion
          });
        });
        return;
      }
      setDownloadedDocumentDetails({
        documentIdentity: documentIdentity,
        lewisVersion: ''
      });
    }
  };
  if (status.searchBusy) {
    return /*#__PURE__*/React.createElement(RubriqLoadingSpinner, {
      text: "loading documents"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3 w-100"
  }, documents.map(function (doc) {
    return /*#__PURE__*/React.createElement(RubriqDocumentCard, {
      key: doc.identity,
      document: doc,
      status: status,
      pagination: pagination,
      isTranslation: isTranslationList,
      onDownload: handleDownload
    });
  })), /*#__PURE__*/React.createElement(RubriqPaginator, {
    totalCount: numberOfResults,
    currentPage: page,
    pageSize: pageSize,
    onPageChange: function onPageChange(page) {
      return setSearchParams({
        page: page
      });
    }
  })), downloadedDocumentDetails.documentIdentity && /*#__PURE__*/React.createElement(RubriqFeatureFeedbackToastNotification, {
    downloadedDocumentIdentity: downloadedDocumentDetails.documentIdentity,
    lewisVersionForDocument: downloadedDocumentDetails.lewisVersion,
    feature: isTranslationList ? RUBRIQ_FEATURES.TRANSLATION : RUBRIQ_FEATURES.EDITING
  }));
};
export default RubriqDocumentList;